<template>
    <div>
        <buttonlist
                @help="help"
                ref="SetBtn"
                @exps="exps"
        ></buttonlist>
        <div style="padding:8px">
            <tr>
                <td>{{$t('getapi[1964]')}}</td>
                <td>
                    <el-input size="mini" v-model="year" maxlength="4"
                              oninput="value=value.replace(/^\.+|[^\d.]/g,'')"></el-input>
                </td>
                <td>{{$t('getapi[2087]')}}</td>
                <td>
                    <el-select filterable v-model="month" size="mini" style="margin-righ:20px">
                        <el-option v-for="item in monthList" :key="item.value" :label="item.label"
                                   :value="item.value"></el-option>
                    </el-select>
                </td>
                <td>{{$t('getapi[8009]')}}</td>
                <td>
                     <el-select v-model="stmethod" size="mini">
                        <el-option v-for="item in stmethod_list" :key="item.value" :label="item.label"
                                    :value="item.value"></el-option>
                    </el-select>
                </td>
                <td>
                    <el-button type="primary" size="mini" @click="confirm">{{$t('getapi[1146]')}}</el-button>
                </td>

                
            </tr>
        </div>
        <el-table
                id="xpane-0"
                :data="dataSet"
                v-loading="loading"
                :highlight-current-row="true"
                show-overflow-tooltip="true"
                border
                stripe
                size="mini"
                :height="tableHeight"
                header-row-class-name="headerclass"
                style="width: 100%; margin-top:0px"
                ref="singleTable"
        >
            <el-table-column type="selection" v-if="isbatch"></el-table-column>
            <el-table-column v-for="item in returnHeadArray"
                             :key="item.ColumnsField"
                             :prop="item.ColumnsField"
                             :label="item.ColumnsName"
                             :align="item.Alignment"
            >
                <template scope="scope">
                    <span v-if="item.ColumnsField =='rate'">
                        {{scope.row.rate}}%
                    </span>
                    <span v-else>
                        <span>{{scope.row[item.ColumnsField]}}</span>
                    </span>
                </template>
            </el-table-column>
        </el-table>
        <!--<el-row>
            <el-col :span="18">
                <el-pagination
                        style="margin-top: 1em"
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :page-sizes="[100, 200, 300, 400]"
                        :page-size="100"
                        :pager-count="5"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="total"
                ></el-pagination>
            </el-col>
            <el-col :span="6">
                <div style="text-align: right;line-height: 60px;color: #545c64;font-size: 95%;">表名/视图名称:{{ DbTbNames }}</div>
            </el-col>
        </el-row>-->
    </div>
</template>

<script>
    import Common from '@/components/Common';
    import Array from '@/components/Array';

    export default {
        name: 'purrateview',
        computed: {
            tableHeight(){
                return this.$windowSize.tableHeight2
            }
        },
        data() {
            return {
                dataSet: [], // 主表数据
                returnHeadArray: [], // 物料主文件表头
                isVisible: false, // 查询列表是否显示
                queryData: [], // 查询数组
                userData: [], // 用户信息
                DbTbNames: '',
                pageIndex: 1, // 当前页
                pageSize: 50, // 当前页数据量
                SelectIndexs: 1, //当前页面
                total: 0, // 数据总量
                loading: false, // 主表加载状态
                year: "", // 年份
                month: "", // 月度
                
                monthList: [
                    {
                        value: 1,
                        label: 1
                    },
                    {
                        value: 2,
                        label: 2
                    },
                    {
                        value: 3,
                        label: 3
                    },
                    {
                        value: 4,
                        label: 4
                    },
                    {
                        value: 5,
                        label: 5
                    },
                    {
                        value: 6,
                        label: 6
                    },
                    {
                        value: 7,
                        label: 7
                    },
                    {
                        value: 8,
                        label: 8
                    },
                    {
                        value: 9,
                        label: 9
                    },
                    {
                        value: 10,
                        label: 10
                    }, {
                        value: 11,
                        label: 11
                    },
                    {
                        value: 12,
                        label: 12
                    }
                ],
                stmethod_list: [
                    {
                        value: 1,
                        label: this.$t('getapi[1507]')//'供应商'
                    },
                    {
                        value: 2,
                        label: this.$t('getapi[1167]')//'采购员'
                    }
                ],
                stmethod:1,//统计方式
                scrollTop:0,
            };
        },
        watch:{
            dataSet: function(){
                let that = this
                that.$nextTick(function() {
                    that.$processdata.initForm(0)
                })
            },
        },
        mounted: function () {
            let that = this;
            that.userData = sessionStorage.getItem('userData');
            // that.stmethod=1;
            that.authority();
        },
        activated () {
            let that = this
            setTimeout(() => {
                that.$refs.singleTable.bodyWrapper.addEventListener('scroll', (res) => {
                    that.scrollTop = res.target.scrollTop
                },false)
            }, 5000);
            // 路由跳转回来滚动到离开时的位置
            this.$nextTick(()=> {
                setTimeout(() => {
                    this.$refs.singleTable.bodyWrapper.scrollTop =this.scrollTop;
                }, 13)
            })
        },
        methods: {
            help(){
                this.$refs.SetBtn.showHelp(this.$options.name,this.$t("getapi[965]"),this.$t("getapi[16]"));
            },
            authority() {
                let that = this;
                if(that.$loadviewfields.isEnableHelp(this.$options.name) == 1){
                    that.$refs.SetBtn.SetOneBtnEnable('help',true);
                }
                if (that.dataSet.length > 0) {
                    that.$refs.SetBtn.SetButtonEnable('export');
                } else {
                    that.$refs.SetBtn.SetButtonEnable('');
                }
            },
            handleSizeChange(val) {
                this.pageSize = val;
                this.getView();
            },
            handleCurrentChange(val) {
                this.pageIndex = val;
                this.getView();
            },
            confirm() {
                let that = this
                let parm = {
                    TYear: that.year,
                    Month: that.month,
                    Type:that.stmethod,
                    LangType:that.$processdata.getLang(),
                }
                that.loading = true;
                that.$http.urlpost('/Pur/Statistics/GetPurRateList', parm, function (res) {
                    if (res.Success == 1) {
                        that.dataSet = res.DataContent.DataList;
                        that.returnHeadArray = res.DataContent.ColumnsList;
                        that.total = res.Totals;
                        that.authority();
                        that.loading = false;
                    }
                });
            },
            exps() {
                let that = this
                let parm = {
                    TYear: that.year,
                    Month: that.month,
                    Type:that.stmethod,
                    LangType:that.$processdata.getLang()
                }
                that.$http.urlpost('/Pur/Statistics/GetPurRateToExecl', parm, function (res) {
                    if (res.Success == 1) {
                        let hrefurl = Common.Url + res.DataContent.URL;
                        window.open(hrefurl);
                    }
                });
            }
        }
    };
</script>

<style scoped lang="less">
    table {
        border-collapse: separate;
        border-spacing: 0px 5px;
        td {
            padding-left: 3px;
            white-space: pre;
        }
    }
</style>
